import { useSelector } from "react-redux";
import { getUserSelectedAccountCode } from "../../app/appSelectors";
import { useCallback } from "react";
import { getLocalStorageItem } from "../../utils/storage/getLocalStorageItem";
import { setLocalStorageItem } from "../../utils/storage/setLocalStorageItem";
import { removeStorageItem } from "../../utils/storage/removeStorageItem";

function useAccountStorage(accountCode?: string) {
    const selectedAccountCode = useSelector(getUserSelectedAccountCode);
    const currentAccountCode = accountCode || selectedAccountCode;

    const setAccountStorageItem = useCallback((name, value) => {
        setLocalStorageItem(currentAccountCode, name, value);
    }, [currentAccountCode]);

    const removeAccountStorageItem = useCallback((name) => {
        removeStorageItem(currentAccountCode, name);
    }, [currentAccountCode])

    const getAccountStorageItem = useCallback((name, def = undefined) => {
        return getLocalStorageItem(currentAccountCode, name, def)
    }, [currentAccountCode]);

    return {
        getAccountStorageItem,
        removeAccountStorageItem,
        setAccountStorageItem,
    };
}

export default useAccountStorage;
